import {PersonIcon} from '@common/icons/material/Person';
import clsx from 'clsx';

// Curated set of pleasant background colors used to render a default
// avatar when a user hasn't uploaded their own image yet.
const DefaultAvatarBackgrounds = [
  '#F87171',
  '#FB923C',
  '#FBBF24',
  '#34D399',
  '#22D3EE',
  '#60A5FA',
  '#818CF8',
  '#A78BFA',
  '#F472B6',
  '#94A3B8',
];

function backgroundForSeed(seed: number): string {
  const index =
    ((seed % DefaultAvatarBackgrounds.length) +
      DefaultAvatarBackgrounds.length) %
    DefaultAvatarBackgrounds.length;
  return DefaultAvatarBackgrounds[index];
}

interface DefaultAvatarProps {
  seed: number;
  className?: string;
}
export function DefaultAvatar({seed, className}: DefaultAvatarProps) {
  return (
    <div
      className={clsx(
        'flex items-center justify-center rounded-full',
        className,
      )}
      style={{backgroundColor: backgroundForSeed(seed)}}
    >
      <PersonIcon
        className="text-white"
        style={{width: '60%', height: '60%'}}
      />
    </div>
  );
}
